module.exports = __webpack_public_path__ + "assets/images/new_logo_horizontal.1b6c2ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_logo_horizontal.png
// module id = 137
// module chunks = 1